import styled from 'styled-components';

import SvgIcon from '../../../SvgIcon';

import { listColors } from './listColors';

export const StarWrapper = styled(SvgIcon)<{ $colorIndex?: number; $blank?: boolean }>`
  margin-right: 10px;
  &.gold-filled {
    svg {
      fill: ${({ theme }) => theme.gold.a10};
      stroke: ${({ theme }) => theme.gold.a10};
    }
  }

  &.colored-list {
    height: 18px;
    width: 18px;
    margin-right: 0.3rem;

    svg {
      stroke-width: 1.5px;
    }

    &.full {
      fill: ${({ $colorIndex, $blank }) => ($blank ? 'white' : listColors[$colorIndex || 0])};
      stroke: ${({ $colorIndex, $blank }) => ($blank ? 'white' : listColors[$colorIndex || 0])};
    }

    &.half {
      color: ${({ $colorIndex, $blank }) => ($blank ? 'white' : listColors[$colorIndex || 0])};
    }

    &.empty {
      stroke: ${({ $colorIndex, $blank }) => ($blank ? 'white' : listColors[$colorIndex || 0])};
      &.white {
        stroke: #fff;
      }
    }
  }
`;

export const DisplayStarsContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  div:last-of-type {
    margin-right: 0;
  }
`;
